<template>
  <form action>
    <div class="modal-card" style="width: auto">
      <header class="modal-card-head" v-if="false">
        <p class="modal-card-title">Seleccionar tipo</p>
      </header>
      <section class="modal-card-body">
        <div class="columns is-centered is-mobile is-multiline">
          <div class="column is-8-mobile">
          <a href="#" @click="irRutaSubirFotos()">
            <figure class="image">
              <img src="@/assets/img/productos/foto-productos.jpg" />
            </figure>
          </a>
          </div>
          <div class="column is-8-mobile">
          <a href="https://tienda.mundofotografico.com.ar">
            <figure class="image">
              <img src="@/assets/img/productos/productos.jpeg" />
            </figure>
          </a>
          </div>
        </div>
      </section>
    </div>
  </form>
</template>

<script>
export default {
  name: 'SelectorTipoProducto',
  methods: {
    irRutaSubirFotos () {
      this.$parent.close()
      this.$router.push({ name: 'subir-fotos' })
    }
  }
}
</script>
